export const EMULATION_SET_SNACKBAR_VISIBILITY = (state, { value }) => ({
  ...state,
  isSnackbarVisible: value
});

export const EMULATION_SET_INTERCEPTORS_ADDED = (state, { value }) => ({
  ...state,
  interceptorsAdded: value
});
